import useClientRepository from "../../../../../../repository/emergency/useClientRepository";
import {useEffect} from "react";
import isNull from "../../../../../../mixin/isNull";
import {TextField} from "@mui/material";
import Box from "@mui/material/Box";

export default function ({clientId, onEmailChange, onPhone1Change}) {
    const clientRepository = useClientRepository();
    /** @type Client */
    const client = clientRepository.findOneById(clientId).select();

    useEffect(() => {
        clientRepository.findOneById(clientId).exec();
    }, []);

    useEffect(() => {
        if (isNull(client)) return;

        onEmailChange(client.getEmail());
        onPhone1Change(client.getPhone1());
    }, [JSON.stringify(client)]);

    if (isNull(client)) return null;

    return (
        <>
            <div>
                <TextField
                    fullWidth
                    variant={"standard"}
                    label={"Téléphone du sociétaire"}
                    defaultValue={client.getPhone1()}
                    onChange={e => onPhone1Change(e.target.value)}
                    data-test="input-client-phone"
                />
            </div>
            <Box mt={2}>
                <TextField
                    fullWidth
                    variant={"standard"}
                    label={"Email du sociétaire"}
                    defaultValue={client.getEmail()}
                    onChange={e => onEmailChange(e.target.value)}
                    data-test="input-client-email"
                />
            </Box>
        </>
    );
}